import { useTranslate } from "@tolgee/react";

import { RoleType } from "../../api/generated/graphql";
import EmptySchedule from "@frontend/lyng/assets/svg/empty/A.svg?react";
import { useCareContext } from "../../providers";

import { Spinner } from "../../components/common";
import { VisitGroups } from "./VisitGroups";
import { useMemo } from "react";
import { Button } from "@frontend/lyng/button";
import { Plus } from "@frontend/lyng/assets/icons/24/outline";
import { useNavigate } from "react-router";
import { useFeatureFlag } from "../../providers/FeatureFlags";
import { getCurrentOrNextVisitId } from "./NowLine";
import { useGetVisits } from "./hook";

export const Schedule = () => {
  const { t } = useTranslate();
  const { viewer } = useCareContext().state;
  const ff_caregiverCreateAndUpdateVisits = useFeatureFlag(
    "CaregiverCreateAndUpdateVisits",
  );
  const navigate = useNavigate();

  const canCreateVisits = useMemo(() => {
    return (
      ff_caregiverCreateAndUpdateVisits &&
      viewer?.tenantAccess.offices.some(
        (office) => office.settings.caregiversCanCreateAndUpdateVisits,
      ) &&
      viewer?.roles.some((role) => role.roleType === RoleType.Caregiver)
    );
  }, [viewer, ff_caregiverCreateAndUpdateVisits]);

  const { groupedVisits, error, loading } = useGetVisits();

  const currentOrNextVisitId = useMemo(() => {
    return getCurrentOrNextVisitId(groupedVisits);
  }, [groupedVisits]);

  if (error) return <p>{error.message}</p>;

  if (loading) return <Spinner />;

  return (
    <div className="flex">
      {Object.keys(groupedVisits).length > 0 ? (
        <div className="flex flex-col flex-auto">
          {canCreateVisits && (
            <Button
              className="mx-4 mb-2"
              onClick={() => navigate("visit/new")}
              variant="secondary"
              icon={Plus}
              iconPosition="right"
              text={t("schedule.addVisitButton")}
            />
          )}
          <VisitGroups
            groupedVisits={groupedVisits}
            nextVisitId={currentOrNextVisitId}
          />
        </div>
      ) : (
        <div className="flex h-full w-full flex-col gap-4 px-5 pt-24">
          <EmptySchedule className="max-w-xs self-center" />
          <p className="text-center text-lg font-medium text-title">
            {t("schedule.noVisits")}
          </p>
          {canCreateVisits && (
            <Button
              className="m-auto"
              onClick={() => navigate("visit/new")}
              variant="primary"
              icon={Plus}
              iconPosition="right"
              text={t("schedule.addVisitButton")}
            />
          )}
        </div>
      )}
    </div>
  );
};
